import React from "react";
import { ArrowUpRight } from "lucide-react";

const SLOT_IMG =
    "https://static.prod-images.emergentagent.com/jobs/0c325fa0-c7de-49b3-9474-6afba2a9cd35/images/38d186547645d13f1dd904dbc42a4cde5a28126a3bf83e1cbbf6f9977146d748.png";
const CASINO_IMG =
    "https://static.prod-images.emergentagent.com/jobs/0c325fa0-c7de-49b3-9474-6afba2a9cd35/images/ace71818d0afcfcea53650fea091c532806154ae46c5f5a28ddf8fa84daebc3f.png";
const FEATURES_IMG =
    "https://static.prod-images.emergentagent.com/jobs/0c325fa0-c7de-49b3-9474-6afba2a9cd35/images/53608520cc403c85a9feca1e4071cf1bc6dd3eac37a1febd7fad00b6a4f1e34f.png";

const categories = [
    {
        title: "Pusatcuan Slot",
        tag: "Paling Populer",
        image: SLOT_IMG,
        desc: "Ribuan game slot online terbaru dengan RTP transparan dari provider top dunia.",
        span: "lg:col-span-7 lg:row-span-2",
    },
    {
        title: "Live Casino",
        tag: "Real Dealer",
        image: CASINO_IMG,
        desc: "Pengalaman kasino live streaming HD langsung dari studio internasional.",
        span: "lg:col-span-5",
    },
    {
        title: "Sportsbook",
        tag: "Semua Liga",
        image: FEATURES_IMG,
        desc: "Taruhan olahraga mulai sepak bola, basket, hingga e-sport.",
        span: "lg:col-span-5",
    },
];

export default function Games() {
    return (
        <section
            id="game"
            data-testid="games-section"
            className="relative py-24 md:py-32"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
                    <div className="max-w-2xl">
                        <span className="text-xs tracking-[0.25em] uppercase text-[#D4AF37]">
                            Kategori Game
                        </span>
                        <h2
                            data-testid="games-title"
                            className="mt-4 text-3xl md:text-5xl font-medium tracking-tighter text-white"
                        >
                            Akses game online terbaru{" "}
                            <span className="text-gold-gradient">dalam satu platform</span>
                        </h2>
                    </div>
                    <p className="text-white/60 max-w-md">
                        Dari pusatcuan slot hingga live casino dan sportsbook — semua
                        tersedia dengan link resmi terpercaya dan proses transaksi
                        instan.
                    </p>
                </div>

                <div className="mt-14 grid grid-cols-1 lg:grid-cols-12 auto-rows-[minmax(280px,1fr)] gap-6 md:gap-8">
                    {categories.map((c, i) => (
                        <a
                            key={c.title}
                            href="#daftar"
                            data-testid={`game-card-${i}`}
                            className={`${c.span} group relative overflow-hidden rounded-3xl border border-white/5 bg-[#0c0c0c] hover:border-[#D4AF37]/40 transition-all`}
                        >
                            <img
                                src={c.image}
                                alt={`${c.title} di PUSATCUAN situs hiburan online terpercaya`}
                                className="absolute inset-0 w-full h-full object-cover opacity-60 group-hover:opacity-80 group-hover:scale-105 transition-all duration-700"
                                loading="lazy"
                            />
                            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
                            <div className="relative h-full flex flex-col justify-end p-8">
                                <span className="inline-flex w-fit items-center px-3 py-1 rounded-full text-[10px] tracking-[0.25em] uppercase text-[#D4AF37] border border-[#D4AF37]/40 bg-black/40 backdrop-blur">
                                    {c.tag}
                                </span>
                                <h3 className="mt-4 text-2xl md:text-4xl font-medium tracking-tight text-white">
                                    {c.title}
                                </h3>
                                <p className="mt-3 text-white/70 max-w-md">{c.desc}</p>
                                <span className="mt-5 inline-flex items-center gap-2 text-sm text-[#D4AF37] group-hover:translate-x-1 transition-transform">
                                    Mainkan Sekarang <ArrowUpRight size={16} />
                                </span>
                            </div>
                        </a>
                    ))}
                </div>
            </div>
        </section>
    );
}
